"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "Group-2",
    transform: "translate(2.000000, 3.000000)",
    stroke: "currentColor",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "link-2",
      transform: "translate(11.211627, 10.111627) rotate(-45.000000) translate(-11.211627, -10.111627) translate(1.311627, 5.711627)",
      strokeWidth: "2",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M12.32,0 L14.96,0 C16.1269526,1.56319402e-15 17.2461098,0.463570098 18.0712698,1.28873016 C18.8964299,2.11389023 19.36,3.23304744 19.36,4.4 C19.36,6.8300529 17.3900529,8.8 14.96,8.8 L12.32,8.8 M7.04,8.8 L4.4,8.8 C3.23304744,8.8 2.11389023,8.3364299 1.28873016,7.51126984 C0.463570098,6.68610977 9.76996262e-17,5.56695256 0,4.4 C-1.95399252e-16,1.9699471 1.9699471,1.77635684e-15 4.4,1.77635684e-15 L7.04,1.77635684e-15",
        id: "Shape"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M6.16,4.4 L13.2,4.4",
        id: "path4645"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      stroke: "currentColor",
      strokeWidth: "4.52030945",
      strokeMiterlimit: "4",
      strokeDasharray: "none",
      id: "arrow-right",
      transform: "matrix(0.29044631,0.28927736,-0.28927736,0.29044631,4.6265488,-0.4489416)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M 0,7 H 14",
        id: "Shape-3",
        strokeWidth: "4.52030945",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        id: "polyline3779",
        points: "7 0 14 7 7 14",
        strokeWidth: "4.52030945",
        strokeMiterlimit: "4",
        strokeDasharray: "none"
      })]
    })]
  })
}));